module.exports = __webpack_public_path__ + "assets/img/2812.c5a47279.png";